import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List, fromJS } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as leakFileActions from 'modules/leakFile';

import { ExamLeakFileList } from 'components';

let SEARCH_VALUE = '';
class CtExamLeakFileList extends Component {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = [
        'searchAll',
        'leakFileNo',
        'fileName',
        'targetName',
        'targetEmail',
        'hostname',
        'examName'
      ];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      fromNowRegDate: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      tempFilter: {}
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, selectedExamSummaryNo, paramData } = this.props;

    if (
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo
    ) {
      this.setState({ currentPage: 0 });
    }

    if (
      (needReload && !this.state.loading) ||
      // 선택한 훈련이 변경되었을 때
      selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData
    ) {
      this.getLeakFile();
    }
  }

  getLeakFile = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { currentPage, pageSize } = this.state;
        const { LeakFileActions, selectedExamSummaryNo, paramData } = this.props;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize
        };
        params.examNo = selectedExamSummaryNo;

        if (params.examNo === 'all') {
          params.examNo = undefined;
        }

        await LeakFileActions.getLeakFile(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  //파일구분 필터
  leakTypeFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['leakTypeArray'] === 'undefined') {
      filter['leakTypeArray'] = [data.value];
    } else {
      const indexArray = filter['leakTypeArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['leakTypeArray'].push(data.value);
      } else {
        filter['leakTypeArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['leakTypeArray'].length === 0 && delete filter['leakTypeArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { LeakFileActions } = this.props;
    LeakFileActions.changeParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { LeakFileActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = [
          'searchAll',
          'leakFileNo',
          'fileName',
          'targetName',
          'targetEmail',
          'hostname',
          'examName'
        ];
        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        LeakFileActions.changeParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  //체크 취소
  cancleCheck = () => {
    const { LeakFileActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter
    });
  };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { LeakFileActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    LeakFileActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { LeakFileActions } = this.props;

    LeakFileActions.changeParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };
  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      loading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { LeakFileActions, paramData } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    LeakFileActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  render() {
    console.log('CtExamLeakFileList - render');
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      loading,
      fromNowRegDate,
      currentPage,
      pageSize,
      fitRowCount,
      searchType,
      searchText,
      tempFilter
    } = this.state;
    const { isAuth, leakFileData, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      leakTypeFilter,
      handleChangeFilter,
      handleChangeDateFilter,
      handleInitFilter,
      takeSearchValue,
      searchTextRef,
      cancleCheck,
      filterClose,
      executeFilter
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();

    const fromNowClass = [];
    if (fromNowRegDate) {
      fromNowClass.push('from-now-reg-date');
    }

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      { key: 0, text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })), value: 'searchAll' },
      { key: 1, text: 'No', value: 'leakFileNo' },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'ExamLeakFileList_6', defaultMessage: '파일명' })),
        value: 'fileName'
      },
      {
        key: 3,
        text: defineMessages(formatMessage({ id: 'ExamLeakFileList_8', defaultMessage: '대상자명' })),
        value: 'targetName'
      },
      {
        key: 4,
        text: defineMessages(formatMessage({ id: 'ExamLeakFileList_9', defaultMessage: '대상자 이메일' })),
        value: 'targetEmail'
      },
      { key: 5, text: 'PC', value: 'hostname' },
      {
        key: 6,
        text: defineMessages(formatMessage({ id: 'ExamLeakFileList_11', defaultMessage: '훈련명' })),
        value: 'examName'
      }
    ];

    return (
      <ExamLeakFileList
        isAuth={isAuth}
        fromNowClass={fromNowClass}
        manual
        data={leakFileData && Map.isMap(leakFileData) ? leakFileData.toJS().success : {}}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        onFetchData={handleFetchData}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          searchTextRef: searchTextRef,
          takeSearchValue: takeSearchValue,
          paramData: paramData,
          tempFilter: tempFilter
        }}
        // 필터
        leakTypeFilter={leakTypeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        cancleCheck={cancleCheck}
        filterClose={filterClose}
        executeFilter={executeFilter}
        // 페이징 처리
        handlePagination={handlePagination}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    leakFileData: state.leakFile.get('data'),
    needReload: state.leakFile.get('needReload'),
    totalPages: state.leakFile.get('totalPages'),
    totalCount: state.leakFile.get('totalCount'),
    paramData: state.leakFile.get('param'),
    isAuth: state.leakFile.get('isAuth'),
    selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected'])
  };
};

const mapDispatchToProps = dispatch => ({
  LeakFileActions: bindActionCreators(leakFileActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamLeakFileList));



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamLeakFileList.js